const {
    REACT_APP_ENV,
    REACT_APP_STRIPE_API_KEY,
    REACT_APP_DROPBOX_APP_KEY,
    REACT_APP_GOOGLE_API_KEY,
    REACT_APP_GOOGLE_APP_ID,
    REACT_APP_GOOGLE_CLIENT_ID,
    REACT_APP_ENABLE_SENTRY_ERROR_REPORTING,
    REACT_APP_SENTRY_DSN
} = process.env;

export const SERVER_URL = process.env.REACT_APP_SERVER_URL || 'http://localhost:3000';

export const FEATURES = {
    EXPORT_TO_GOOGLE_DRIVE: 'EXPORT_TO_GOOGLE_DRIVE',
    EXTEND_EXPIRY: 'EXTEND_EXPIRY',
    EXPORT_TO_DROPBOX: 'EXPORT_TO_DROPBOX',
    DOWNLOAD_NOTIFICATIONS: 'DOWNLOAD_NOTIFICATIONS'
};

export const ENVIRONMENT = REACT_APP_ENV;
export const DROPBOX_APP_KEY = REACT_APP_DROPBOX_APP_KEY;
export const GOOGLE_API_KEY = REACT_APP_GOOGLE_API_KEY;
export const GOOGLE_APP_ID = REACT_APP_GOOGLE_APP_ID;
export const GOOGLE_APP_CLIENT_ID = REACT_APP_GOOGLE_CLIENT_ID;
export const STRIPE_API_KEY = REACT_APP_STRIPE_API_KEY;
export const ENABLE_SENTRY_ERROR_REPORTING = REACT_APP_ENABLE_SENTRY_ERROR_REPORTING;
export const SENTRY_DSN = REACT_APP_SENTRY_DSN;
